/**
 * Count-up animation for Key Stats numbers
 * Runs once when each .block-key-stats__number enters the viewport.
 */

document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.block-key-stats__number');

  if (!counters.length) return;

  const observerOptions = { root: null, threshold: 0.4 };

  // Easing for smoother feel
  const easeOutQuad = (t) => t * (2 - t);

  const animateCount = (el) => {
    // Preserve original target via data attribute so re-renders don't shrink target.
    let targetAttr = el.getAttribute('data-count-target');
    if (!targetAttr) {
      // Fallback: derive from initial text, then store.
      targetAttr = el.textContent.replace(/[^\d.-]/g, '');
      el.setAttribute('data-count-target', targetAttr);
    }
    const target = parseFloat(targetAttr);
    if (isNaN(target)) return; // nothing to animate

    // Determine suffix strategy:
    // If there is a sibling .block-key-stats__suffix element, we keep number clean and leave suffix span alone.
    // Otherwise, if original text had a trailing non-digit symbol (%, +, k, M), we append it during animation.
    const parentValueWrap = el.closest('.block-key-stats__value');
    const siblingSuffixEl = parentValueWrap ? parentValueWrap.querySelector('.block-key-stats__suffix') : null;
    let inlineSuffix = '';
    if (!siblingSuffixEl) {
      const originalText = el.textContent.trim();
      const matchSuffix = originalText.match(/([%+kM])$/i); // basic common suffixes
      inlineSuffix = matchSuffix ? matchSuffix[1] : '';
    }

    const duration = 1500; // ms
    const startTime = performance.now();

    const update = (time) => {
      const rawProgress = Math.min((time - startTime) / duration, 1);
      const progress = easeOutQuad(rawProgress);
      const value = Math.floor(progress * target);
      // Write number only if we have a sibling suffix; else number+inlineSuffix.
      el.textContent = siblingSuffixEl ? value : value + inlineSuffix;
      if (rawProgress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = siblingSuffixEl ? target : target + inlineSuffix; // ensure exact target at end
      }
    };

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Guard to prevent repeated partial animations; mark counted.
        if (!entry.target.classList.contains('has-counted')) {
          entry.target.classList.add('has-counted');
          animateCount(entry.target);
        }
        // Optional: unobserve after first run to reduce overhead.
        obs.unobserve(entry.target);
      }
    });
  }, observerOptions);

  counters.forEach(counter => observer.observe(counter));
});
